import { isValidTaxIdentifier, normalizeTaxIdentifier } from './tax-identifier-validator';

const DEFAULT_MESSAGE = 'CPF ou CNPJ inválido.';

function isValidTaxIdentifierYup(message, options = {}) {
  return this.test('isValidTaxIdentifier', message, function (value) {
    const { path, createError } = this;

    if (!value) {
      return createError({ path, message: message || DEFAULT_MESSAGE });
    }

    const normalized = normalizeTaxIdentifier(value);

    if (!isValidTaxIdentifier(normalized, options)) {
      return createError({ path, message: message || DEFAULT_MESSAGE });
    }

    return true;
  });
}

export default isValidTaxIdentifierYup;
